import store from '@/store';
import BillerView from '@/pages/biller';

const defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ?
  process.env.DEFAULT_ROUTE_NAME : process.env.DEFAULT_BILLER_ROUTE_NAME;

const requireBiller = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    return next({ name: 'Login' });
  } else if (store.getters.needResetPwd && ['ResetPassword', 'Logout'].indexOf(to.name) === -1) {
    return next({ name: 'ResetPassword' });
  } else if (store.getters.isAdmin) {
    return next({ name: 'Logout' });
  }
  // check if we have user's info or not
  // check if we have company info or not
  // if not, we try reloading them
  return next();
};

const requireBillerAdmin = (to, from, next) => {
  if (store.getters.myAdminInfo) {
    if (store.getters.myAdminInfo.role === 'ADMIN') {
      return requireBiller(to, from, next);
    }
  }
  return next({ name: defaultRouteName });
};

const routes = [
  // Company
  {
    path: '/',
    name: 'BillerUserLoadInfo',
    component: BillerView.userLoadInfo,
    beforeEnter: requireBiller,
    meta: {
      title: 'กำลังโหลด...',
    },
  },
  {
    path: '/company',
    name: 'BillerCompanyDetail',
    component: BillerView.companyDetail,
    beforeEnter: requireBiller,
    meta: {
      title: 'รายละเอียดบริษัท',
    },
  },
  {
    path: '/company/edit',
    name: 'BillerCompanyEdit',
    component: BillerView.companyEdit,
    beforeEnter: requireBillerAdmin,
    meta: {
      title: 'แก้ไขรายละเอียดบริษัท',
    },
  },
  {
    path: '/profiles',
    name: 'BillerProfileList',
    component: BillerView.profileList,
    beforeEnter: requireBiller,
    meta: {
      title: 'รายการข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  {
    path: '/profiles/:profileId',
    props: true,
    name: 'BillerProfileDetail',
    component: BillerView.profileDetail,
    beforeEnter: requireBiller,
    meta: {
      title: 'รายละเอียดข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  {
    path: '/profiles/:profileId/edit',
    props: true,
    name: 'BillerProfileEdit',
    component: BillerView.profileForm,
    beforeEnter: requireBillerAdmin,
    meta: {
      title: 'แก้ไขข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  // Slips
  {
    path: '/profiles/:profileId/slips/create',
    props: true,
    name: 'BillerSlipCreate',
    component: BillerView.slipForm,
    beforeEnter: requireBiller,
    meta: {
      title: 'เพิ่มข้อมูลบริษัทสำหรับรับชำระ',
    },
  },
  {
    path: '/profiles/:profileId/slips/:slipId/edit',
    props: true,
    name: 'BillerSlipEdit',
    component: BillerView.slipForm,
    beforeEnter: requireBiller,
    meta: {
      title: 'แก้ไขข้อมูลผู้ชำระ',
    },
  },
  // Users
  {
    path: '/users',
    name: 'BillerUserList',
    component: BillerView.userList,
    beforeEnter: requireBillerAdmin,
    meta: {
      title: 'รายการบัญชีผู้ใช้ระบบของบริษัท',
    },
  },
  {
    path: '/users/create',
    name: 'BillerUserCreate',
    component: BillerView.userForm,
    beforeEnter: requireBillerAdmin,
    meta: {
      title: 'สร้างบัญชีผู้ใช้ระบบของบริษัท',
    },
  },
  {
    path: '/users/:userId',
    props: true,
    name: 'BillerUserEdit',
    component: BillerView.userForm,
    beforeEnter: requireBillerAdmin,
    meta: {
      title: 'แก้ไขบัญชีผู้ใช้ระบบของบริษัท',
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes/biller.js